export default "__VITE_ASSET__BWODDE9e__"